export default "__VITE_ASSET__BXjTNa8u__"